<script>
import EntitiesTable from '$common/EntitiesTable'
export default {
  name: 'AdminGiftCards',
  components: {
    'entities-table': EntitiesTable,
  },
  data () {
    return {
      giftCards: [],
      cells: [
        {
          name: 'Gift Card',
          getInfo: giftCard => giftCard.id,
          sortFunc: (a, b) => a.id.localeCompare(b.id),
          onClick: (giftCard) => {
            this.$modals.show({
              name: 'redemption-list',
              type: 'gift_cards',
              id: giftCard.id,
            })
          },
        },
        {
          name: 'Redeemed',
          getInfo: giftCard => `${giftCard.vouchers_redeemed}/${giftCard.vouchers}`,
          sortFunc: (a,b) => a.vouchers_redeemed < b.vouchers_redeemed ? 1 : -1,
        },
        {
          name: 'Created',
          getInfo: giftCard => new Date(giftCard.created).toLocaleDateString(),
          sortFunc: (a, b) => (a.created || 0) < (b.created || 0) ? 1 : -1
        },
        {
          name: 'Buyer',
          getInfo: giftCard => `${giftCard.buyer.fname} ${giftCard.buyer.lname}`,
          sortFunc: (a, b) => a.buyer.fname.localeCompare(b.buyer.fname)
        },
        {
          name: 'Buyer Email',
          getInfo: giftCard => giftCard.buyer.email,
          sortFunc: (a, b) => a.buyer.email.localeCompare(b.buyer.email)
        },
        {
          name: 'Recipient',
          getInfo: giftCard => `${giftCard.recipient.fname} ${giftCard.recipient.lname}`,
          sortFunc: (a, b) => a.recipient.fname.localeCompare(b.recipient.fname)
        },
        {
          name: 'Recipient Email',
          getInfo: giftCard => giftCard.recipient.email,
          sortFunc: (a, b) => a.recipient.email.localeCompare(b.recipient.email)
        },
      ],
      sorting: {
        ascending: true,
        by: 'Created',
      },
      isReady: false,
    }
  },
  computed: {
    filteredGiftCards () {
      const sortFunc = this.cells.find(cell => cell.name === this.sorting.by).sortFunc
      const sorted = this.$clone(this.giftCards).sort(sortFunc)
      return this.sorting.ascending ? sorted : sorted.reverse()
    },
  },
  methods: {
    async getGiftCards () {
      return new Promise(async (resolve, reject) => {
        const giftCards = (await this.$firestore.collection('gift_cards').get()).docs.map(doc => doc.data())
        return resolve(giftCards)
      })
    },
  },
  async mounted () {
    this.giftCards = await this.getGiftCards()
    this.isReady = true
  },
}
</script>

<template lang="pug">
  #admin-gift-cards-main.admin-main
    .admin-gift-cards-container.admin-container
      .admin-title GiftCards
      .admin-content
        entities-table(
          :entities='filteredGiftCards'
          :cells='cells'
          :initialSorting='sorting'
          :isReady='isReady'
          customColumnWidths='250px 105px 150px 200px 300px 200px 300px'
          @onSortingChange='newSorting => sorting = newSorting'
          :tableStyle='{"max-width": "calc(100vw - 400px)"}'
        )
</template>

<style lang="sass" scoped>
  #admin-invoices-main
    .admin-invoices-container
</style>